import { Menu } from 'antd';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { signOut } from '../../store/actions/auth';

const SideMenu = ({ auth }) => {
  const dispatch = useDispatch();
  return (
    <Menu
      mode="inline"
      style={{ height: '100%', borderRight: 0, marginTop: 20 }}
    >
      <Menu.Item key="1">
        <NavLink
          to="/"
          className="flex text-base font-medium text-black text-opacity-50"
          activeClassName="text-yellow-500 text-opacity-100"
        >
          Home
        </NavLink>
      </Menu.Item>
      <Menu.Item key="2">
        <NavLink
          to="/hielocos"
          className="flex text-base font-medium text-black text-opacity-50"
          activeClassName="text-yellow-500 text-opacity-100"
        >
          Hielocos
        </NavLink>
      </Menu.Item>
      {auth.user.admin && (
        <Menu.Item key="3">
          <NavLink
            exact
            className="flex text-base font-medium text-black text-opacity-50"
            activeClassName="text-yellow-500 text-opacity-100"
            to="/usuarios"
          >
            Usuarios
          </NavLink>
        </Menu.Item>
      )}
      <button
        onClick={() => dispatch(signOut())}
        className="flex text-base ml-6 font-medium hover:text-blue-500 mt-2"
      >
        Cerrar sesión
      </button>
    </Menu>
  );
};

export default SideMenu;
